import React from 'react'
import styled from 'styled-components'
import * as Layout from 'views/layouts/MainLayout/MainLayout'
import * as Header from 'views/ui/Header/Header'
import { Button, FormComponents } from '@agro-club/frontend-shared'
import { useTranslation } from 'react-i18next'

const Id = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.color.onPrimaryDark};
  opacity: 0.48;
  margin-top: 4px;
`

const ItemGenericError: React.FC<{
  id?: string
  title?: string
  errorText?: string | null
  onBack?(): void
}> = ({ id, onBack, title, errorText }) => {
  const { t } = useTranslation('layouts')
  return (
    <>
      <Layout.Header>
        <Header.Root onClickBack={onBack}>
          {title ? <Header.Title size={'small'} title={title} /> : null}
          {!!id && <Id>{`ID ${id}`}</Id>}
        </Header.Root>
      </Layout.Header>
      <Layout.Content>
        <FormComponents.FormContentWrapper>
          <FormComponents.FormContentBody>
            <div>{errorText || t('itemGenericError.description')}</div>
            <div>
              <Button onClick={onBack} intent={'primary'}>
                {t('itemGenericError.goBackButtonText')}
              </Button>
            </div>
          </FormComponents.FormContentBody>
        </FormComponents.FormContentWrapper>
      </Layout.Content>
    </>
  )
}

export default ItemGenericError
